export const tempMedia = {};